import { useQuery } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import type { User } from '@/models/user';
import { api_account_user_path } from '@/utils/routes';

export const useUser = (enabled = true) => {
  const response = useQuery<{ data: User }>({
    queryKey: [clientKeys.useUser],
    queryFn: () => falconClient.get(api_account_user_path()),
    enabled,
  });

  return { user: response?.data?.data, ...response };
};
